module.exports = __webpack_public_path__ + "img/kid_color.f9fe19b2.png";